import React from 'react';
import { Paper, Box, Typography } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';

const ProjectMetricsSummary = () => {
  const rowData = [
    { metric: 'Project Miles', value: '-' },
    { metric: 'Project Diameter', value: '-' },
    { metric: '/in-mile', value: '$' },
    { metric: 'Contingency %', value: '0%' },
    { metric: 'Total Contingency', value: '$' },
    { metric: 'Total Tax', value: '$' },
  ];

  const columnDefs = [
    { headerName: 'Metric', field: 'metric', flex: 1, cellStyle: { fontWeight: '500', fontSize: '14px' } },
    { headerName: 'Value', field: 'value', flex: 1, cellStyle: { textAlign: 'left', fontSize: '14px' } },
  ];

  return (
    <Paper
      elevation={4}
      sx={{
        borderRadius: 3,
        overflow: 'hidden',
        p: 0,
        backgroundColor: '#223A64',
        border: '1px solid #e0e0e0',
      }}
    >
      {/* Title */}
      <Box
        sx={{
          backgroundColor: '#223A64',
          py: 2,
          textAlign: 'center',
        }}
      >
        <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold', fontSize: '18px' }}>
          Project Metrics
        </Typography>
      </Box>

      {/* Table */}
      <Box
        className="ag-theme-alpine"
        sx={{
          width: '100%',
          '& .ag-root-wrapper': { border: 'none' },
          '& .ag-header': { display: 'none' },
          '& .ag-row': { borderBottom: '1px solid #eee' },
          '& .ag-cell': { display: 'flex', alignItems: 'center' },
        }}
      >
        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          headerHeight={0}
          domLayout="autoHeight"
          suppressMenuHide
          suppressCellFocus
          suppressMovableColumns
          suppressColumnVirtualisation
          defaultColDef={{
            resizable: true,
            sortable: false,
            filter: false,
          }}
        />
      </Box>
    </Paper>
  );
};

export default ProjectMetricsSummary;
